module.exports = __webpack_public_path__ + "static/img/bg3.300b020f.png";